<script setup lang="ts">
import { useWindowScroll } from "@vueuse/core";

const { backgroundColor, id, isPreview } = defineProps<{
    backgroundColor: string;
    id: string;
    isPreview: boolean;
}>();

const { y } = useWindowScroll();
</script>

<template>
    <header
        class="inset-x-0 p-4 lg:px-6 top-0 shadow-sm z-10"
        :class="{ fixed: !isPreview && y > 0 }"
        :style="{ backgroundColor }"
        :id="id"
    >
        <slot />
    </header>
</template>
